import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '../rootReducer';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { HttpMethods, SERVICES } from '../../services/api';
import { UserTypes } from '../../components/common/domain/userTypes';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { FilterOperators, Ifilter } from '../../components/common/filters/interfaces';
import {
  actions as userListActions
} from '../../slices/users/list';
import { ListParams } from '../utils';
import { ActiveInactiveFilterState } from '../../components/common/activeInactiveToggle';

export interface IUpdateUserTypePayload {
  userType: UserTypes.AccountAdmin | UserTypes.User;
  id: string;
  accountId: string;
  currentPage?: number;
}

export const updateUserTypeById: AsyncThunk<void, IUpdateUserTypePayload, ThunkAPI> = createAsyncThunk(
  '',
  async (user: IUpdateUserTypePayload, thunk) => {
    try {
      const { currentPage = 1 } = user;
      delete user.currentPage;
      const response = await basicApiAsyncThunkCreator<void, IUpdateUserTypePayload>({
        endpoint: 'users',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Patch,
        contentType: 'application/json'
      })(user, thunk);
      const request: ListParams<Ifilter[]> = {
        active: ActiveInactiveFilterState.Active,
        filters: [{
          field: 'accountId',
          operands: [user.accountId],
          operator: FilterOperators.isAnyOf,
          validateInputs: false
        }],
        pagination: { offset: (currentPage - 1) * 25, limit: 25 }
      };
      thunk.dispatch(userListActions.fetchUsersList(request));
      thunk.dispatch(showSuccessMessage('User updated'));
      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage('Your request failed, please try again later or contact support'));
      return thunk.rejectWithValue(err);
    }
  }
);
